export const GET_CITY_MISSIONS = 'GET_CITY_MISSIONS'
export const GET_CITY_MISSIONS_SUCCESS = 'GET_CITY_MISSIONS_SUCCESS'

export const GET_CITY_INVENTORIES = 'GET_CITY_INVENTORIES'
export const GET_CITY_INVENTORIES_SUCCESS = 'GET_CITY_INVENTORIES_SUCCESS'

export const GET_CITY_MISSIONS_AND_INVENTORIES =
  'GET_CITY_MISSIONS_AND_INVENTORIES'
export const GET_CITY_MISSIONS_AND_INVENTORIES_SUCCESS =
  'GET_CITY_MISSIONS_AND_INVENTORIES_SUCCESS'

export const FILTER_CITY_PICKUP = 'FILTER_CITY_PICKUP'

export const UPDATE_CITY_BY_ID_GRAPH_QL = 'UPDATE_CITY_BY_ID_GRAPH_QL'
export const UPDATE_CITY_BY_ID_GRAPH_QL_SUCCESS =
  'UPDATE_CITY_BY_ID_GRAPH_QL_SUCCESS'
export const UPDATE_CITY_BY_ID_GRAPH_QL_FAILURE =
  'UPDATE_CITY_BY_ID_GRAPH_QL_FAILURE'

export const GET_CITY_PICKUP_TIME = 'GET_CITY_PICKUP_TIME'
export const GET_CITY_PICKUP_TIME_SUCCESS = 'GET_CITY_PICKUP_TIME_SUCCESS'

export const CREATE_CITY_PICKUP_TIME = 'CREATE_CITY_PICKUP_TIME'
export const CREATE_CITY_PICKUP_TIME_SUCCESS = 'CREATE_CITY_PICKUP_TIME_SUCCESS'

export const CITY_GET_CITIES = 'CITY_GET_CITIES'
export const CITY_GET_CITIES_SUCCESS = 'CITY_GET_CITIES_SUCCESS'
export const CITY_GET_CITIES_ERROR = 'CITY_GET_CITIES_ERROR'
export const CITY_SET_FILTER_COUNTRY = 'CITY_SET_FILTER_COUNTRY'
export const CITY_SET_FILTER_STATUS = 'CITY_SET_FILTER_STATUS'
export const CITY_FILTER_STATUS = {
  ALL: null,
  ACTIVE: 'active',
  ARCHIVE: 'archived',
}
